module.exports = require("dom-helpers/events/on");


//////////////////
// WEBPACK FOOTER
// external "dom-helpers/events/on"
// module id = 19
// module chunks = 0